// config.js
const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    WHATSAPP_URL: "https://wa.me/",
    INSTAGRAM_URL: "https://www.instagram.com/",
    accountID: process.env.NEW_RELIC_ACCOUNT_ID,
    trustKey: process.env.NEW_RELIC_TRUST_KEY,
    agentID: process.env.NEW_RELIC_AGENT_ID,
    licenseKey: process.env.NEW_RELIC_LICENSE_KEY,
    applicationID: process.env.NEW_RELIC_APPLICATION_ID,
  };

export default config;
